<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      岗厦北<br>
站点介绍<br>
岗厦北站位于福田区深南大道与彩田路交叉口处，车站主体沿深南路呈东西走向布置。岗厦北站是14号线与2&8号线、10号线和11号线换乘站。车站色彩基调以白色调为主，以“深圳之眼”为主题，引入费马螺旋线双向延伸，体现“汇聚、包容、国际化”文化特征。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:26	23:48	10号线	3分40秒	6分钟<br>
双拥街	06:19	23:06	10号线	3分40秒	6分钟<br>
岗厦北	--	--	11号线	5分15秒	6分25秒<br>
碧头	06:20	23:30	11号线	5分15秒	6分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:26	23:48	10号线	4分50秒	7分钟<br>
双拥街	06:19	23:06	10号线	4分50秒	7分钟<br>
岗厦北	--	--	11号线	5分15秒	6分25秒<br>
碧头	06:00	23:30	11号线	5分15秒	6分25秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:26	23:48	10号线	4分50秒	7分钟<br>
双拥街	06:19	23:06	10号线	4分50秒	7分钟<br>
岗厦北	--	--	11号线	－	－<br>
碧头	06:20	23:30	11号线	－	－<br><br>

站点出口信息<br><br>
1号口:<br>
深圳中心公园、天健世纪花园、深圳市当代艺术与城市规划馆<br><br>
7号口:<br>
星河世纪大厦、卓悦中心、金地中心、中银大厦、中洲大厦<br><br>
12号口:<br>
大中华国际交易广场、福华新村、深大新村、福田中学、深圳国际文化大厦、岗厦村、嘉麟豪庭、彩天名苑、文蔚大厦<br><br>
19号口:<br>
福建大厦、田面新村、田面城市大厦、城市绿洲学校、富荔花园、深圳市第一职业技术学校（福田校区）、彩德城、福景大厦、国际人才大厦、福田科技广场、彩霞阁、振业花园、福莲花园、长福花园<br><br>
B出入口:<br>
深南大道北侧、深圳市第一职业技术学校、国际创新中心、中国邮政储蓄银行、福田区行政服务大厅<br><br>
D出入口:<br>
深南大道北侧、彩田路、宏嘉酒店、中广核大厦、深圳边防支队、平安国际酒店、华润万佳、凤凰大厦<br><br>
公交换乘信息<br><br>
1号出入口:<br>
公交站名： 海关综合大楼<br>
113、204、223、M132、M133、M190、M414、高峰专线49<br><br>
7号出入口:<br>
公交站名： 彩福大厦<br>
M329、M389、高峰专线23<br><br>
7号出入口:<br>
公交站名： 海关综合大楼<br>
M132、高峰专线49、113、204、M133、M190、M414、223<br><br>
12号出入口:<br>
公交站名： 岗厦北地铁站①<br>
113、204、303、320、326、M103、M106、M133、M190、M414、M447、M448、高峰专线119、高快巴士40号、高快巴士47号、高快巴士60号、223、高峰专线221号<br><br>
12号出入口:<br>
公交站名： 岗厦北地铁站②<br>
101、223、高峰专线221号、M102<br><br>
19号出入口:<br>
公交站名： 岗厦北地铁站①<br>
113、320、326、M133、M363、M414、M447、M448、M190、204、223、101、高峰专线119<br><br>
B出入口:<br>
公交站名： 岗厦北地铁站 ①（北侧）<br>
113、320、326、M133、M363、M414、M435、M447、M448、M190、N04、204、223、K204、101、高专038、高专119、高快25<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shihaoxian",
            title: "10号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>